<template lang="pug">
  div
    content-loader(:height="7", v-if="alert.loading")
    p(v-else-if='report.rentals.length < 1') No rentals
    b-card(v-else-if="report && report.rentals.length > 0")
      .p-2.text-right
        a.text-primary(@click="generateReport()")
          font-awesome-icon(icon="file")
          span.ml-2 DOWNLOAD
      vue-html2pdf(ref="html2Pdf", filename="report", :enable-download="true",:paginate-elements-by-height="1400" :show-layout="true", :float-layout="false", pdf-format="a4")
        .container(slot="pdf-content")
          .row
            .col-6
              h1 RENTAL REGISTER
              p WALL COLLECTIVE CO
              p STELLENBOSCH
              p 7600
            .col-6.text-right
              span
                span.font-weight-bold REPORT DATE:
                span.ml-1 {{ report.date_pretty }}
          .row.text-center
            .col-3
              h3 {{ report.total }}
              span RENTALS
            .col-3
              h3 {{ formatRands(report.value) }}
              span VALUE
            .col-3
              h3 {{ report.customers }}
              span CUSTOMERS
            .col-3
              h3 {{ report.artists }}
              span ARTISTS
          hr
          .row.mt-5
            .col-3
              h4 PIECE
            .col-3
              h4 PERIOD
            .col-3
              h4 CUSTOMER
            .col-3
              h4 LOCATION
          hr
          .row(v-for="rental in report.rentals")
            .col-3
              span.mt-0 {{ rental.product.title }}
              p.m-1 {{ rental.artist_name }}
              p.m-1 {{ formatRands(rental.product.price) }}
            .col-3
              ul.list-unstyled
                li
                    span.font-weight-bold From
                    span.ml-1 {{ rental.date_start_pretty }}
                li
                  span.font-weight-bold To
                  span.ml-1 {{ rental.date_end_pretty }}
            .col-3
              ul.list-unstyled
                li
                    span.ml-1 {{ rental.customer.name }}
            .col-3
              ul.list-unstyled
                li
                    span.ml-1 {{ rental.address.line_1 }}
                li(v-if="rental.address.line_2 ")
                    span.ml-1 {{ rental.address.line_2 }}
                li
                    span.ml-1 {{ rental.address.city }}
                li
                    span.ml-1 {{ rental.address.zip }}
            .col-12
              hr
    nothing(v-else="")
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';
import VueHtml2pdf from 'vue-html2pdf';

export default {
  name: 'Rental',
  components: {
    ContentLoader,
    VueHtml2pdf,
  },
  mixins: [standardMix],
  data() {
    return {
      report: null,
    };
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
  async created() {
    this.loading();
    this.report = await apiService.getReport('rental');
    this.clear();
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/ReportsRentals.vue